import React, { useCallback, useEffect, useState } from 'react'
import CustomInput from '../../../Components/InputCompo/CustomInput'
import CustomSelection from '../../../Components/SelectionComp/CustomSelection'
import { ParagraphComp } from '../../../Components/ParagraphComp/ParagraphComp'
import HeaderCompo from '../../../Components/HeaderComp/HeaderCompo'
import ButtonComp from '../../../Components/ButtonComp/ButtonComp'
import { useMutation, useQuery } from '@tanstack/react-query'
import { InputCompo } from '../../../Components/InputCompo/InputCompo'
import * as Yup from 'yup';
import { FieldArray, Form, Formik, useFormikContext } from 'formik'
import { allCountries } from '../RegistrationDatas'
import CustomFileInput from '../../../Components/InputCompo/CustomFileInput'
import { m } from 'framer-motion'
import { fadeIn } from '../../../Functions/GlobalAnimations'
import { enqueueSnackbar } from 'notistack'
import { BronzeSectionSubPost, financeSection2Get, financeSection2Post, editRegistration } from '../../../Store/auth/register'
import MultipleSelect from '../../../Components/SelectionComp/MultipleSelect'
import CustomTextarea from '../../../Components/textareaComp/CustomTextarea'
import Loading from '../../../Components/Loader/Loading'
import CloseIcon from "@mui/icons-material/Close";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import AddCommentIcon from "@mui/icons-material/AddComment";
import ModalComp from "../../../Components/ModalComp";
import { debounce } from 'lodash'
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';

const RecieptsAndPayments = ({ setSubTabs }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const reg_key = localStorage.getItem("RegKey");
  const [selectedRows, setSelectedRows] = useState([]);
  const gsnNoFromStorage = localStorage.getItem('gsn_no');
  const { isLoading: fieldLoading, data: questions } = useQuery({
    queryKey: 'financeSec2',
    queryFn: () => financeSection2Get(gsnNoFromStorage ? gsnNoFromStorage : ''),
    cacheTime: 1000 * 60 * 5,
    staleTime: 0,
  });
  if (!gsnNoFromStorage) {
    setSubTabs({ "Operations Planning & Management": true })
  }

  // validations for fields
  const modelSchema = Yup.object({
    normalFields: Yup.object(
      questions?.documents?.reduce((schema, fields) => {
        let fieldValidation = Yup.string();
        if (fields.depend_question && fields.condition && fields?.type?.toLowerCase() !== 'section') {
          fieldValidation = fieldValidation.test(
            'dependent-condition',
            `${fields.question} is required when the condition is met`,
            function (value) {
              const { parent } = this;
              const dependentValue = parent[fields.depend_question];
              const isConditionMet = evaluateCondition(dependentValue, fields.condition, fields.value);
              return isConditionMet ? !!value : true;
            }
          );
        }
        if (fields.validation.toLowerCase() === 'email') {
          fieldValidation = fieldValidation.test(
            'match-dependent',
            ` Re-enter your organisation's primary email address to 
confirm it's correct. This must match the email entered above to ensure 
successful registration`,
            function (value) {
              const { parent } = this;
              const dependentValue = parent[fields.depend_question];
              if (dependentValue) {
                return value === dependentValue;
              }
              return true;
            }
          );
        } else if (fields.type.toLowerCase() === 'password') {
          fieldValidation = fieldValidation.test(
            'match-dependent',
            `Re-enter your password to confirm it matches the one you 
created above. This ensures your password is set correctly`,
            function (value) {
              const { parent } = this;
              const dependentValue = parent[fields.depend_question];
              if (dependentValue) {
                return value === dependentValue;
              }
              return true;
            }
          );
        }

        if (fields.validation.toLowerCase() === 'email' && !fields.depend_question) {
          fieldValidation = fieldValidation.matches(
            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
            'Invalid email address'
          );
        } else if (fields.validation.toLowerCase() === 'pan') {
          fieldValidation = fieldValidation.matches(
            /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
            'Invalid PAN Number. It should be in the format: ABCDE1234F.'
          );
        } else if (fields.validation.toLowerCase() === 'pincode') {
          fieldValidation = fieldValidation.matches(
            /^\d{4}$|^\d{6}$/,
            'PIN code must be exactly 6 digits'
          );
        } else if (fields.validation.toLowerCase() === 'areacode') {
          fieldValidation = fieldValidation.matches(/^(123|456|789)$/, 'Incorrect area code');
        } else if (fields.type.toLowerCase() === 'multiselect dropdown') {
          fieldValidation = Yup.array();
        } else if (fields.validation.toLowerCase() === 'website') {
          fieldValidation = fieldValidation.url('Please enter a valid URL');
        } else if (fields.validation.toLowerCase() === 'mobile') {
          fieldValidation = fieldValidation.matches(/^(?:[0-9]{10}|[0-9]{7})$/, 'Invalid contact number');
        } else if (fields.type.toLowerCase() === 'attach') {
          fieldValidation = Yup.object();
        } else if (fields.validation.toLowerCase() === 'darpan') {
          fieldValidation = fieldValidation.test(
            'is-valid-darpan',
            ' Darpan Id should be in the format: XX/1234/1234567',
            (value) => value?.toUpperCase() === 'NA' || /^([A-Z]{2}\/\d{4}\/\d{7})$/.test(value)
          );
        } else if (fields.validation.toLowerCase() === 'password' && !fields.depend_question) {
          fieldValidation = fieldValidation.min(8, 'Password must be at least 8 characters long');
        }

        if (!fields.depend_question && fields.type.toLowerCase() !== 'section' && fields?.mandatory === 1) {
          fieldValidation = fieldValidation.required(`${fields?.question} is required`);
        }

        schema[fields?.question_no] = fieldValidation;
        return schema;
      }, {})
    ),
    ...questions?.documents?.reduce((sectionSchemas, fields) => {
      if (fields.type.toLowerCase() === 'section') {
        sectionSchemas[fields.template] = Yup.array().of(
          Yup.object(fields.sub_questions.reduce((subSchema, subField) => {
            let subFieldValidation = Yup.string();

            if (subField.depend_question && subField.condition) {
              subFieldValidation = subFieldValidation.test(
                'dependent-condition',
                `${subField.question} is required when the condition is met`,
                function (value) {
                  const { parent } = this;
                  const dependentValue = parent[subField.depend_question];
                  const isConditionMet = evaluateCondition(dependentValue, subField.condition, subField.value);
                  return isConditionMet ? !!value : true;
                }
              );
            }

            if (subField?.validation?.toLowerCase() === 'email') {
              subFieldValidation = subFieldValidation.matches(
                /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                'Invalid email address'
              );
            } else if (subField.validation?.toLowerCase() === 'pan') {
              subFieldValidation = subFieldValidation.matches(
                /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
                'Invalid PAN Number. It should be in the format: ABCDE1234F.'
              );
            } else if (subField?.validation?.toLowerCase() === 'pincode') {
              subFieldValidation = subFieldValidation.matches(
                /^\d{4}$|^\d{6}$/,
                'PIN code must be exactly 6 digits'
              );
            } else if (subField.type.toLowerCase() === 'attach') {
              subFieldValidation = Yup.object();
            }
            else if (subField.type.toLowerCase() === 'multiselect dropdown') {
              subFieldValidation = Yup.array();
            }
            else if (subField?.validation?.toLowerCase() === 'mobile') {
              subFieldValidation = subFieldValidation.matches(/^(?:[0-9]{10}|[0-9]{7})$/, 'Invalid contact number');
            }

            if (subField.mandatory === 1) {
              subFieldValidation = subFieldValidation.required(`${subField.question} is required`);
            }

            subSchema[subField.question_no] = subFieldValidation;
            return subSchema;
          }, {}))
        );
      }
      return sectionSchemas;
    }, {}),
  });

  const handleCreateSuccess = () => {
    setSubTabs({ "Income & Expenditure": true })
    enqueueSnackbar('success!', { variant: 'success' });
  };

  const handleCreateError = (error) => {
    if (error?.response?.data.status_code >= 500) {
      enqueueSnackbar(error?.response?.data?.status_message, { variant: 'error' });
    } else {
      enqueueSnackbar(error?.response?.data?.message || error?.message, { variant: 'error' });
    }
  };

  const createFarmerMutationOptions = {
    onSuccess: handleCreateSuccess,
    onError: handleCreateError,
  };

  const {
    mutate: submitInitialReg,
    data: regFinalData,
    isPending: mainRegistration
  } = useMutation({
    mutationFn: financeSection2Post,
    ...createFarmerMutationOptions,
  });

  const attachFile = (e, setFieldValue) => {
    const file = e.target.files[0];
    const name = e.target.name;
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result.split(',')[1];
        setFieldValue(name, { attach_file: base64String, file_name: file.name });
      };
      reader.readAsDataURL(file);
    }
  };

  const evaluateCondition = (value1, condition, value2) => {
    switch (condition) {
      case '==':
        return value1 == value2;
      case '===':
        return value1 === value2;
      case '!==':
        return value1 !== value2
      case '>':
        return value1 > value2;
      case '<':
        return value1 < value2;
      case '>=':
        return value1 >= value2;
      case '<=':
        return value1 <= value2;
      default:
        return false;
    }
  };

  const createInitialValues = () => {
    if (questions?.docs_answers?.length > 0) {
      return questions.docs_answers.reduce((values, field) => {
        if (field.type.toLowerCase() === 'section') {
          if (field?.answer?.length > 0) {
            const tempData = [];
            field.answer.forEach((Row, index) => {
              Row.forEach(Field => {
                if (!tempData[index]) tempData[index] = {};
                if (Field.type.toLowerCase() === 'multiselect dropdown') {
                  tempData[index][Field?.question_no] = Field?.answer?.split(',') || [];
                }
                else if (Field?.type.toLowerCase() === "attach") {
                  tempData[index][Field?.question_no] = { file_name: Field?.upload_document }
                }
                else {
                  tempData[index][Field?.question_no] = Field?.answer || '';
                }
              });
            });
            values[field.template] = values[field.template] || tempData;
          } else {
            values[field.template] = values[field.template] || [{}];
            values[field.template].forEach(row => {
              field?.sub_questions?.forEach(subField => {
                row[subField?.question_no] = subField?.question === 'Country Code' ? '+91 - India' : '';
              });
            });
          }
        } else {
          values.normalFields = values.normalFields || {};
          if (field?.question_no) {
            if (field.type.toLowerCase() === 'multiselect dropdown') {
              values.normalFields[field.question_no] = field?.answer?.split(',') || [];
            } else if (field?.type.toLowerCase() === "attach") {
              values.normalFields[field.question_no] = { file_name: field?.upload_document }
            }
            else {
              values.normalFields[field.question_no] = field?.answer || '';
            }
          }
        }
        return values;
      }, {});
    } else {
      return questions?.documents?.reduce((values, field) => {
        values.normalFields = values.normalFields || {};
        values.normalFields[field?.question_no] = '';

        if (field.type.toLowerCase() === 'section') {
          if (field?.answer?.length > 0) {
            const tempData = [];
            field.answer.forEach((Row, index) => {
              Row.forEach(Field => {
                if (!tempData[index]) tempData[index] = {};
                tempData[index][Field?.question_no] = Field?.answer || '';
              });
            });
            values[field.template] = values[field.template] || tempData;
          } else {
            values[field.template] = values[field.template] || [{}];
            values[field.template].forEach(row => {
              field?.sub_questions?.forEach(subField => {
                row[subField?.question_no] = subField?.question === 'Country Code' ? '+91 - India' : '';
              });
            });
          }
        }
        return values;
      }, {});
    }
  };

  const toggleAllRows = (e, values, template) => {
    const isChecked = e.target.checked;
    setSelectedRows(isChecked ? { [template]: values?.[template]?.map((_, index) => index) } : []);
  };

  const toggleRowSelection = (rowIndex, template) => {
    setSelectedRows((prevSelected) => {
      const selectedRowsForTemplate = prevSelected?.[template] || [];
      return {
        ...prevSelected,
        [template]: selectedRowsForTemplate.includes(rowIndex)
          ? selectedRowsForTemplate.filter((index) => index !== rowIndex)
          : [...selectedRowsForTemplate, rowIndex],
      };
    });
  };

  const deleteSelectedRows = (remove, template) => {
    selectedRows?.[template].sort((a, b) => b - a);
    selectedRows?.[template].forEach((index) => remove(index));
    setSelectedRows([]);
  };

  const DisplayFormikValues = () => {
    const { values, setFieldValue } = useFormikContext();

    const parseAmount = (val) => {
      if (val === '' || val == null) return 0;
      const num = parseFloat(String(val).replace(/,/g, ''));
      return Number.isFinite(num) ? num : 0;
    };

    const sectionAmountFieldIds = (template, totalFieldId) => {
      const subQuestions =
        questions?.documents?.find((d) => d?.template === template)
          ?.sub_questions || [];
      const totalIndex = subQuestions.findIndex(
        (sq) => sq?.question_no === totalFieldId,
      );
      return subQuestions
        .filter((sq, index) => {
          const type = sq?.type?.toLowerCase();
          const beforeTotal =
            totalIndex === -1
              ? sq?.question_no !== totalFieldId
              : index < totalIndex;
          return (
            sq?.question_no &&
            beforeTotal &&
            (type === 'float' || type === 'number')
          );
        })
        .map((sq) => sq.question_no);
    };

    const calculateValues = useCallback(debounce(() => {
      const UserInputs = values?.['Payments'];
      if (UserInputs?.length > 0) {
        if (!UserInputs) return;
        const fieldIds = sectionAmountFieldIds('Payments', 'SQ-00163');
        UserInputs.forEach((value, index) => {
          const TotalSlab = fieldIds.reduce(
            (sum, id) => sum + parseAmount(value?.[id]),
            0
          );
          if (fieldIds.some((id) => parseAmount(value?.[id]))) {
            setFieldValue(`Payments.${index}.SQ-00163`, TotalSlab);
          }
        });
      }
    }, 300), [values, setFieldValue, questions]);

    const calculateValues2 = useCallback(debounce(() => {
      const UserInputs = values?.['Receipts'];
      if (UserInputs?.length > 0) {
        if (!UserInputs) return;
        const fieldIds = sectionAmountFieldIds('Receipts', 'SQ-00155');
        UserInputs.forEach((value, index) => {
          const TotalSlab = fieldIds.reduce(
            (sum, id) => sum + parseAmount(value?.[id]),
            0
          );
          if (fieldIds.some((id) => parseAmount(value?.[id]))) {
            setFieldValue(`Receipts.${index}.SQ-00155`, TotalSlab);
          }
        });
      }
    }, 300), [values, setFieldValue, questions]);

    useEffect(() => {
      calculateValues();
      return () => calculateValues.cancel();
    }, [values?.['Payments'], calculateValues]);

    useEffect(() => {
      calculateValues2();
      return () => calculateValues2.cancel();
    }, [values?.['Receipts'], calculateValues2]);
    return null;
  };

  const SubmitData = async (values) => {
    let tempData = values?.['normalFields']
    // Save all section tables first and wait for them to commit, so the
    // refetch triggered after navigation returns the freshly saved data.
    const sectionSaves = (questions?.documents || [])
      .filter((ele) => ele?.type?.toLowerCase() === "section" && values?.[ele.template])
      .map((ele) => submitTable(gsnNoFromStorage, { [ele.template]: values?.[ele.template] }));
    await Promise.all(sectionSaves);

    const FinalData = questions?.documents?.map(fields => {
      if (fields?.type?.toLowerCase() === "attach") {
        return {
          question_no: fields?.question_no,
          attach_file: tempData?.[fields?.question_no]?.attach_file,
          file_name: tempData?.[fields?.question_no]?.file_name
        };
      } else if (fields?.type.toLowerCase() === 'number') {
        return {
          question_no: fields?.question_no,
          answer: `${tempData[fields?.question_no]}`
        };
      }
      else if (fields?.type.toLowerCase() === 'checkbox') {
        return {
          question_no: fields?.question_no,
          answer: `${tempData[fields?.question_no] ? 'Y' : 'N'}`
        };
      }
      else if (fields?.type.toLowerCase() === 'multiselect dropdown' && tempData?.[fields?.question_no]) {
        return {
          question_no: fields?.question_no,
          answer: `${tempData?.[fields?.question_no].map(ele => { return ele })}`
        };
      }
      else {
        return {
          question_no: fields?.question_no,
          answer: tempData[fields?.question_no]
        };
      }
    });

    const currentDate = new Date().toISOString().split('T')[0]
    const structuredData = {
      args: {
        name: gsnNoFromStorage,
        section_last_updated_on: currentDate,
        receipts_payments_question_answers: FinalData
      }
    };

    submitInitialReg(structuredData);
  }

  const multiSelectedValues = (name, question_no, value, setFieldValue) => {
    setFieldValue(name, value)
  }

  const submitTable = async (gsn, data) => {
    if (gsn) {
      try {
        const sections = questions?.documents?.filter(ele => ele.type.toLowerCase() === 'section');
        await Promise.all(sections.map(async (Sec) => {
          let passedValues = {
            args: {
              gsn_num: gsn,
              main_question_no: Sec?.question_no,
              question_answers: []
            }
          };
          if (Sec?.template && data?.[Sec?.template]) {
            data?.[Sec?.template].forEach((ele, index) => {
              let tempQuestion_answers = [];
              Sec.sub_questions.forEach(Sub => {
                if (Sub.type.toLowerCase() === 'attach' && ele[Sub.question_no] || Sub.type.toLowerCase() === 'attach' && ele[Sub.question_no] === '') {
                  tempQuestion_answers.push({
                    question_no: Sub.question_no,
                    file_name: ele[Sub.question_no]?.file_name || '',
                    attach_file: ele[Sub.question_no]?.attach_file || ''
                  });
                } else if (Sub.type.toLowerCase() === 'multiselect dropdown' && ele[Sub.question_no]) {
                  tempQuestion_answers.push({
                    question_no: Sub.question_no,
                    answer: `${ele[Sub.question_no].map(ele => { return ele })}`
                  });
                }
                else {
                  tempQuestion_answers.push({
                    question_no: Sub.question_no,
                    answer: ele[Sub.question_no]
                  });
                }
                passedValues.args.question_answers[index] = tempQuestion_answers;
              });
            });
          }

          if (passedValues.args.question_answers.length > 0 && passedValues.args.question_answers.some(ele => ele.some(Qn => Qn.answer || Qn.attach_file))) {
            await submitSubReg(passedValues);
          }
        }));
      } catch (error) {
        // handle error
      }
    }
  };

  const {
    mutateAsync: submitSubReg,
    isPending: subLoading,
  } = useMutation({
    mutationFn: BronzeSectionSubPost,
    ...createFarmerMutationOptions,
  });

  const OpenModal = (
    name,
    data,
    values,
    type,
    template,
    index,
    sub_question_num,
    subQuestion
  ) => {
    setIsModalOpen({
      [name]: true,
      data,
      values,
      type: type,
      index: index,
      template: template,
      sub_question_num: sub_question_num,
      subQuestion,
    });
  };

  const CloseModal = () => {
    if (!editLoading) {
      setIsModalOpen("");
    }
  };

  // FIXED: Removed invalid `await` before object literals and before `new Date()`
  const updateValues = async (values) => {
    try {
      const currentDate = new Date();
      let structuredData;
      if (isModalOpen?.type?.toLowerCase() === 'section') {
        const PreviousData = Array.isArray(questions?.docs_answers?.find(doc => doc?.template === isModalOpen?.template)?.answer) && questions?.docs_answers?.find(doc => doc?.template === isModalOpen?.template)?.answer?.[isModalOpen?.index]?.find(ans => ans.question_no === isModalOpen?.data.question_no);
        structuredData = {
          args: {
            gsn_number: gsnNoFromStorage,
            date_and_time: formatDateTime(currentDate),
            gsi_id: reg_key,
            question_id: isModalOpen?.sub_question_num,
            subquestion_id: isModalOpen?.data?.question_no,
            subquestion_previous_answer: PreviousData?.answer,
            subquestion_edited_answer: values?.[isModalOpen?.data?.question_no],
            subquestion_text: isModalOpen?.data?.question,
            question_text: isModalOpen?.subQuestion,
            section_name: 'Receipts & Payments'
          }
        };
      } else {
        structuredData = {
          args: {
            gsn_number: gsnNoFromStorage,
            date_and_time: formatDateTime(currentDate),
            gsi_id: reg_key,
            question_id: isModalOpen?.data?.question_no,
            question_text: isModalOpen?.data?.question,
            previous_answer: isModalOpen?.type?.toLowerCase() === 'section' ?
              values?.[isModalOpen?.template]?.[isModalOpen?.index]?.[isModalOpen?.data?.question_no] ||
              (questions?.docs_answers?.length > 0 &&
                questions?.docs_answers?.find(doc => doc?.template === isModalOpen?.template)?.answer?.find(ele => ele.question_no === isModalOpen?.data.question_no)) || '' :
              values?.normalFields?.[isModalOpen?.data?.question_no] ||
              (questions?.docs_answers?.length > 0 &&
                questions?.docs_answers?.find(doc => doc?.question_no === isModalOpen?.data?.question_no)?.answer) || '',
            edited_answer: values?.[isModalOpen?.data?.question_no],
            section_name: 'Receipts & Payments'
          }
        };
      }
      console.log("structuredData>>>>", structuredData);
      await editData(structuredData);
    } catch (error) {
      // handle error
    }
  };

  const formatDateTime = (isoString) => {
    const date = new Date(isoString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  };

  const editModalSchema = Yup.object().shape({
    [isModalOpen?.data?.question_no]: (() => {
      let validation = Yup.string();
      if (!isModalOpen?.data) return validation;
      const fieldType = isModalOpen.data.type?.toLowerCase();
      const fieldValidation = isModalOpen.data.validation?.toLowerCase();

      if (fieldValidation === "email" && !isModalOpen.data?.depend_question) {
        validation = validation.matches(
          /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
          "Invalid email address"
        );
      } else if (fieldValidation === "pan") {
        validation = validation.matches(
          /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
          "Invalid PAN Number. Format: ABCDE1234F."
        );
      } else if (fieldValidation === "pincode") {
        validation = validation.matches(
          /^\d{4}$|^\d{6}$/,
          "PIN code must be exactly 4 or 6 digits"
        );
      } else if (fieldValidation === "mobile") {
        validation = validation.matches(
          /^(?:[0-9]{10}|[0-9]{7})$/,
          "Invalid contact number"
        );
      } else if (fieldValidation === "website") {
        validation = validation.url("Please enter a valid URL");
      } else if (fieldValidation === "darpan") {
        validation = validation.test(
          "is-valid-darpan",
          "Darpan ID should be in the format: XX/1234/1234567",
          (value) =>
            value?.toUpperCase() === "NA" ||
            /^([A-Z]{2}\/\d{4}\/\d{7})$/.test(value)
        );
      } else if (
        fieldValidation === "password" &&
        !isModalOpen.data?.depend_question
      ) {
        validation = validation.min(
          8,
          "Password must be at least 8 characters long"
        );
      } else if (fieldType === "multiselect dropdown") {
        validation = Yup.array().of(Yup.string());
      } else if (fieldType === "attach") {
        validation = Yup.object();
      }

      if (isModalOpen.data.mandatory === 1) {
        validation = validation.required(
          `${isModalOpen.data.question} is required`
        );
      }

      return validation;
    })(),
  });

  const modalMultiSelectedValues = (values, setModalFieldValue) => {
    const fieldPath = `normalFields.${isModalOpen?.data?.question_no}`;
    setModalFieldValue(fieldPath, values?.[isModalOpen?.data?.question_no]);
    CloseModal();
  };

  const createNewRow = (sub_questions) => {
    let newRow = {};
    sub_questions.forEach((subField) => {
      newRow[subField.question_no] = "";
    });
    return newRow;
  };

  const hasAnswerForQuestion = () => {
    if (!questions?.docs_answers?.length) return false;
    const hasAnyAnswer = questions?.docs_answers?.length > 0 && questions?.docs_answers?.some(doc => doc?.answer)
    const doc = questions.documents
      .map(template => questions.docs_answers.find(doc => doc?.template === template?.template))
      .find(Boolean);
    const isAnyAnswerFilled = Array.isArray(doc?.answer) && doc.answer.some(ele =>
      Array.isArray(ele) && ele.some(dt => dt?.answer)
    );
    return isAnyAnswerFilled || hasAnyAnswer;
  };

  const { mutate: editData, isPending: editLoading } = useMutation({
    mutationFn: editRegistration,
    ...createFarmerMutationOptions,
  });

  useEffect(() => {
    if (!editLoading) {
      setIsModalOpen("");
    }
  }, [editLoading]);

  if (fieldLoading || subLoading || mainRegistration) return (<Loading />)

  return (
    <>
      <Formik
        initialValues={createInitialValues()}
        enableReinitialize={true}
        onReset={false}
        validationSchema={modelSchema}
        onSubmit={SubmitData}
      >
        {({ values, errors, handleChange, touched, handleBlur, setFieldValue }) => (
          <Form className='flex flex-col gap-[30px]' action="">
            <div className='flex flex-wrap gap-[30px] justify-between w-[100%]'>
              {questions?.documents.map((Fields) =>

                <>
                  {Fields?.paremeter &&
                    <div key={Fields.question_no} className='w-[100%]'>
                      <HeaderCompo className='text-2xl text-black' text={Fields?.paremeter} tagType='h3' />
                    </div>
                  }
                  {
                    Fields.type.toLowerCase() === 'text' || Fields.type.toLowerCase() === 'number' || Fields.type.toLowerCase() === 'float' || Fields.type.toLowerCase() === 'date' || Fields.type.toLowerCase() === 'password' ?
                      <div key={Fields.question_no} className={`${evaluateCondition(values?.normalFields?.[Fields?.depend_question], Fields.condition, Fields.value) && Fields?.depend_question && values?.normalFields?.[Fields?.depend_question] ? 'block' : Fields?.depend_question ? 'hidden' : 'block'} ${Fields?.question.toLowerCase() === 'comment box' ? 'w-[100%]' : ' w-[100%]'}  `}>
                        <div>
                          <CustomInput required={Fields?.mandatory > 0 ? true : false}
                            type={Fields.type.toLowerCase() === "float" ? 'number' : Fields.type.toLowerCase()}
                            name={`normalFields.${Fields.question_no}`} label={Fields.question}
                            value={values?.normalFields?.[Fields.question_no]}

                            onChange={(e) => {
                              let value = e.target.value;
                              if (Fields.type.toLowerCase() === "float") {
                                const decimalIndex = value.indexOf('.');
                                if (decimalIndex !== -1) {
                                  const decimalPart = value.substring(decimalIndex + 1);
                                  if (decimalPart.length > 2) {
                                    enqueueSnackbar(`${Fields?.question} can only have up to 2 decimal places`, { variant: 'warning' });
                                    value = value.substring(0, decimalIndex + 3);
                                  }
                                }
                              }
                              e.target.value = value;
                              handleChange(e);
                            }}
                          />
                          <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={values?.normalFields?.[Fields.question_no] && errors.normalFields?.[Fields.question_no]} />
                          <ParagraphComp className='mt-[8px] text-[#5A5A5A] text-sm px-[8px]' text={Fields.description} />
                        </div>
                      </div >

                      :
                      Fields.type.toLowerCase() === 'dropdown'
                        ?
                        <div key={Fields.question_no} className={`${evaluateCondition(values?.normalFields?.[Fields?.depend_question], Fields.condition, Fields.value) && Fields?.depend_question && values?.normalFields?.[Fields?.depend_question] ? 'block' : Fields?.depend_question ? 'hidden' : 'block'} w-[100%]`}>
                          <>
                            <CustomSelection required={Fields?.mandatory > 0 ? true : false}
                              options={Fields?.options}
                              value={values?.normalFields?.[Fields.question_no]}
                              onChange={handleChange}
                              name={`normalFields.${Fields.question_no}`}
                              label={Fields?.question}
                            />
                            <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={values?.normalFields?.[Fields.question_no] && errors?.normalFields?.[Fields.question_no]} />
                            <ParagraphComp className='mt-[8px] text-[#5A5A5A] text-sm px-[8px]' text={Fields.description} />                                        </>
                        </div>
                        :
                        Fields.type.toLowerCase() === 'text area'
                          ?
                          <div key={Fields.question_no} className={`${evaluateCondition(values?.normalFields?.[Fields?.depend_question], Fields.condition, Fields.value) && Fields?.depend_question && values?.normalFields?.[Fields?.depend_question] ? 'block' : Fields?.depend_question ? 'hidden' : 'block'} ${Fields?.question.toLowerCase() === 'comment box' ? 'w-[100%]' : ' w-[100%]'}  `}>
                            <CustomTextarea required={Fields?.mandatory > 0 ? true : false}
                              type={Fields.type.toLowerCase()}
                              name={`normalFields.${Fields.question_no}`} label={Fields.question}
                              value={values?.normalFields?.[Fields.question_no]}
                              onChange={handleChange}
                            />
                            <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={values?.normalFields?.[Fields.question_no] && errors.normalFields?.[Fields.question_no]} />
                            <ParagraphComp className='mt-[8px] text-[#5A5A5A] text-sm px-[8px]' text={Fields.description} />
                          </div>
                          :
                          Fields?.type.toLowerCase() === 'multiselect dropdown' ?
                            <div key={Fields.question_no} className={` ${Fields?.description?.length > 150 ? 'w-[100%]' : ' w-[100%]'} `}>
                              <MultipleSelect
                                required={Fields?.mandatory > 0 ? true : false}
                                options={
                                  Fields?.question_no === "DRQ-00077" ?
                                    Fields?.options?.filter(ele => values?.['normalFields']?.['DRQ-00076']?.includes(ele.value)) : Fields?.options
                                }
                                maxSelect={Fields.validation === 'Select Upto 3' && 3}
                                mappingKey={Fields?.question_no !== "DRQ-00077" ? "option" : 'option'}
                                onValueChange={(name, values) => multiSelectedValues(name, Fields.question_no, values, setFieldValue)}
                                selectedValues={values?.normalFields?.[Fields?.question_no] || []}
                                name={`normalFields.${Fields?.question_no}`}
                                label={Fields?.question}
                              />
                            </div>
                            :
                            Fields.type.toLowerCase() === 'attach' ?
                              <div key={Fields.question_no} className={`${evaluateCondition(values?.normalFields?.[Fields?.depend_question], Fields.condition, Fields.value) && Fields?.depend_question && values?.normalFields?.[Fields?.depend_question] ? 'block' : Fields?.depend_question ? 'hidden' : 'block'} ${Fields?.question?.length > 80 ? 'w-[100%]' : ' w-[100%]'}`}>
                                <div >
                                  <>
                                    <CustomFileInput
                                      required={Fields?.mandatory > 0 ? true : false}
                                      onChange={(e) => attachFile(e, setFieldValue)}
                                      value={values?.normalFields?.[Fields?.question_no]?.file_name}
                                      name={`normalFields.${Fields.question_no}`}
                                      label={Fields?.question}
                                    />
                                    <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={values?.normalFields?.[Fields.question_no] && errors.normalFields?.[Fields.question_no]} />
                                    <ParagraphComp className='mt-[8px] text-[#5A5A5A] text-sm px-[8px]' text={Fields.description} />                                              </>
                                </div>
                              </div>
                              : ''
                  }
                  {
                    Fields.type.toLowerCase() === 'section' ?
                      <>
                        <div key={Fields.question_no} className={`w-[100%] ${evaluateCondition(values?.normalFields?.[Fields?.depend_question], Fields.condition, Fields.value) && Fields?.depend_question && values?.normalFields?.[Fields?.depend_question] ? 'block' : Fields?.depend_question ? 'hidden' : 'block'} `} style={{ marginBottom: '40px', }}>

                          <FieldArray name={Fields.template}>
                            {({ push, remove }) => (
                              <>
                                <div className='w-[100%]'>
                                  <div className='p-[20px] w-[100%] border-2 rounded-t-xl flex items-center justify-between'>
                                    <HeaderCompo className='text-xl text-black mt-0 m-0' tagType='h3' text={Fields.template} />
                                    <div className='flex gap-[20px]'>
                                      {selectedRows?.[Fields?.template]?.length > 0 &&
                                        <m.div {...fadeIn}>
                                          < ButtonComp type='button' onClick={() => deleteSelectedRows(remove, Fields.template)} text='Delete' className='px-[20px] h-[40px] text-[#004878] border-2 bg-transparent border-[#004878] rounded-full py-[5px]' />
                                        </m.div>
                                      }

                                      <ButtonComp
                                        type='button'
                                        onClick={() => push(createNewRow(Fields?.sub_questions))}
                                        text='Add'
                                        className='px-[20px] h-[40px] text-white bg-[#004878] rounded-full py-[5px]'
                                      />
                                    </div>
                                  </div>
                                  <div className='overflow-scroll border-2' >
                                    <table className='text-[#667085] rounded-t-2xl w-[100%]' style={{ display: 'flex', alignItems: 'center', justifyContent: 'start' }}>
                                      <thead style={{ display: 'flex', flexDirection: 'row' }}>
                                        <tr style={{ display: 'flex', flexDirection: 'column' }} className='border-r-2'>
                                          <th className='p-[10px]'>
                                            <div className='w-[20px]'>
                                              {values?.[Fields?.template]?.length > 0 ?
                                                <InputCompo
                                                  type="checkbox"
                                                  className='w-[20px] h-[50px]'
                                                  checked={values?.[Fields?.template]?.length > 0 && selectedRows?.[Fields?.template]?.length === values?.[Fields?.template]?.length}
                                                  onChange={(e) => toggleAllRows(e, values, Fields?.template)}
                                                />
                                                : ''}
                                            </div>
                                          </th>
                                          <th className='p-[10px] py-[0px] w-[50px] h-[50px]'>No.</th>
                                          {Fields.sub_questions.map((subQ) => (
                                            <th key={subQ.question_no} className='p-[10px] min-w-[250px] h-[75px]'>
                                              {subQ.question}
                                            </th>
                                          ))}
                                        </tr>
                                      </thead>
                                      <tbody style={{ display: 'flex', flexDirection: 'row' }}>
                                        {values?.[Fields.template]?.map((row, rowIndex) => (
                                          <tr key={rowIndex} className='border-r-2' style={{ display: 'flex', flexDirection: 'column' }}>
                                            <td className='p-[10px]'>
                                              <InputCompo
                                                className='w-[20px] h-[20px]'
                                                type="checkbox"
                                                checked={selectedRows?.[Fields?.template]?.includes(rowIndex)}
                                                onChange={() => toggleRowSelection(rowIndex, Fields.template)}
                                              />
                                            </td>
                                            <td className='p-[10px] min-w-[50px]'>
                                              {rowIndex + 1}
                                            </td>
                                            {Fields.sub_questions.map((subQ) => (
                                              <td key={subQ.question_no} className='p-[10px] min-w-[250px] max-w-[250px]'>
                                                {subQ.type === 'Dropdown' ? (
                                                  <div className='flex gap-[10px]'>
                                                    <CustomSelection
                                                      required={subQ?.mandatory > 0 ? true : false}
                                                      imgKey='flag'
                                                      exDataKey={subQ?.question === 'Country Code' ? 'label' : undefined}
                                                      mappingKey={subQ?.question === 'Country Code' ? 'phone' : undefined}
                                                      options={subQ?.question === 'Country Code' ? allCountries : subQ?.options}
                                                      onChange={handleChange}
                                                      onBlur={handleBlur}
                                                      name={`${Fields?.template}.${rowIndex}.${subQ.question_no}`}
                                                      value={row?.[subQ.question_no]}
                                                      label="Select"
                                                    />
                                                  </div>
                                                ) : (subQ.type === 'Text' || subQ.type === 'Float' || subQ.type === 'Number' || subQ.type === 'Date') ? (
                                                  <div className='flex gap-[10px]'>
                                                    <CustomInput
                                                      required={subQ?.mandatory > 0 ? true : false}
                                                      options={subQ?.options}
                                                      type={subQ.type.toLowerCase() === "float" ? 'number' : subQ.type.toLowerCase()}
                                                      onChange={(e) => {
                                                        let value = e.target.value;
                                                        if (subQ.type.toLowerCase() === "float") {
                                                          const decimalIndex = value.indexOf('.');
                                                          if (decimalIndex !== -1) {
                                                            const decimalPart = value.substring(decimalIndex + 1);
                                                            if (decimalPart.length > 2) {
                                                              enqueueSnackbar(`${subQ?.question} can only have up to 2 decimal places`, { variant: 'warning' });
                                                              value = value.substring(0, decimalIndex + 3);
                                                            }
                                                          }
                                                        }
                                                        e.target.value = value;
                                                        handleChange(e);
                                                      }}
                                                      onBlur={handleBlur}
                                                      name={`${Fields?.template}.${rowIndex}.${subQ.question_no}`}
                                                      value={row?.[subQ.question_no]}
                                                      label={subQ.question === 'Telephone Number' ? 'Enter the number here' : 'Enter'}
                                                    />
                                                  </div>
                                                ) :
                                                  (subQ.type.toLowerCase() === 'attach')
                                                    ? (
                                                      <CustomFileInput
                                                        required={subQ?.mandatory > 0 ? true : false}
                                                        onChange={(e) => attachFile(e, setFieldValue)}
                                                        name={`${Fields?.template}.${rowIndex}.${subQ.question_no}`}
                                                        value={row?.[subQ.question_no]?.file_name}
                                                        label={subQ.question} />
                                                    )
                                                    :
                                                    (subQ.type.toLowerCase() === 'multiselect dropdown')
                                                      ? (
                                                        <MultipleSelect
                                                          maxSelect={Fields.validation === 'Select Upto 3' && 3}
                                                          required={
                                                            subQ?.mandatory > 0 || evaluateCondition(row?.[subQ?.depend_question], subQ.condition, subQ.value)
                                                          }
                                                          onValueChange={(name, values) => multiSelectedValues(name, Fields?.question_no, values, setFieldValue)}
                                                          options={subQ?.options}
                                                          mappingKey="option"
                                                          selectedValues={row?.[subQ?.question_no] || []}
                                                          name={`${Fields?.template}.${rowIndex}.${subQ?.question_no}`}
                                                          label={subQ?.question}
                                                        />
                                                      ) : (
                                                        ''
                                                      )}

                                                {errors?.[Fields.template]?.[rowIndex]?.[subQ.question_no] &&
                                                  row?.[subQ.question_no] &&
                                                  <div className="error">
                                                    {errors?.[Fields.template][rowIndex][subQ.question_no]}
                                                  </div>}
                                              </td>
                                            ))}
                                          </tr>
                                        ))}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </>
                            )}
                          </FieldArray>
                        </div>
                      </>
                      : ''
                  }
                </>
              )}
              <DisplayFormikValues />
            </div >
            <div className='flex justify-end'>
              <ButtonComp type='submit' className='px-[20px] py-[6px] h-[40px] text-white bg-[#004878] rounded-full' text='Save & Next' />
            </div>
            <ModalComp width={'35%'} modalIsOpen={isModalOpen?.['comment']} closeModal={CloseModal} >
              <HeaderCompo className='text-2xl mb-[10px] font-bold text-black mt-[10px] text-center' tagType={'h3'} text='Comment' />
              <ParagraphComp className='text-lg text-black text-center' >
                {isModalOpen?.type?.toLowerCase() === 'section' ?
                  ((questions?.docs_answers?.length > 0 &&
                    Array.isArray(questions?.docs_answers?.find(doc => doc?.template === isModalOpen?.template)?.answer)) &&
                    questions?.docs_answers?.find(doc => doc?.template === isModalOpen?.template)?.answer?.[isModalOpen?.index]?.find(doc => doc?.question_no === isModalOpen?.data?.question_no)?.comments_for_npo) || 'No comment was added by the administrator' :
                  (questions?.docs_answers?.length > 0 &&
                    questions?.docs_answers?.find(doc => doc?.question_no === isModalOpen?.data?.question_no)?.comments_for_npo) || 'No comment was added by the administrator.'}
              </ParagraphComp>
              <div className="flex justify-end">
                <ButtonComp onClick={CloseModal} type='button' className=' mt-[10px] py-[5px] px-[10px] rounded-[20px] border-2 border-[#004878] text-[#004878]'>
                  Close
                </ButtonComp>
              </div>
            </ModalComp>
            <ModalComp width={'35%'} modalIsOpen={isModalOpen?.['edit']} closeModal={CloseModal} >
              <Formik
                initialValues={{
                  [isModalOpen?.data?.question_no]: ''
                }}
                validationSchema={editModalSchema}
                onSubmit={(values) => {
                  updateValues(values, setFieldValue)
                }}
              >
                {({ values: modalValues, errors: modalErrors, handleChange, setFieldValue: setModalFieldValue }) => (
                  <Form action="">
                    <div className='h-auto'>
                      <div className='flex justify-end'>
                        <div className='cursor-pointer' onClick={CloseModal}>
                          <CloseIcon />
                        </div>
                      </div>
                      <HeaderCompo className='text-2xl mb-[10px] font-bold text-black mt-[10px] text-center' tagType={'h3'} text='Edit' />
                      <ParagraphComp className='text-lg text-black text-start' text='Question' />
                      <ParagraphComp className='text-md mt-[10px] text-[#3f3f3f] text-start' text={isModalOpen?.data?.question} />
                      {(isModalOpen?.type?.toLowerCase() === 'section' ?
                        values?.[isModalOpen?.template]?.[isModalOpen?.index]?.[isModalOpen?.data?.question_no] ||
                        ((questions?.docs_answers?.length > 0 &&
                          Array.isArray(questions?.docs_answers?.find(doc => doc?.template === isModalOpen?.template)?.answer)) && questions?.docs_answers?.find(doc => doc?.template === isModalOpen?.template)?.answer?.[isModalOpen?.index]?.find(ele => ele?.question_no === isModalOpen?.data.question_no))?.answer || '' :
                        values?.normalFields?.[isModalOpen?.data?.question_no] ||
                        (questions?.docs_answers?.length > 0 &&
                          questions?.docs_answers?.find(doc => doc?.question_no === isModalOpen?.data?.question_no)?.answer))
                        ?
                        <ParagraphComp className='text-lg mt-[10px] text-black text-start' text='Current Answer' />
                        : ''
                      }
                      <ParagraphComp className='text-md mt-[10px] text-[#3f3f3f] text-start' >
                        {isModalOpen?.type?.toLowerCase() === 'section' ?
                          values?.[isModalOpen?.template]?.[isModalOpen?.index]?.[isModalOpen?.data?.question_no] ||
                          ((questions?.docs_answers?.length > 0 &&
                            Array.isArray(questions?.docs_answers?.find(doc => doc?.template === isModalOpen?.template)?.answer)) &&
                            questions?.docs_answers?.find(doc => doc?.template === isModalOpen?.template)?.answer?.find(ele => ele.question_no === isModalOpen?.data.question_no)) || '' :
                          values?.normalFields?.[isModalOpen?.data?.question_no] ||
                          (questions?.docs_answers?.length > 0 &&
                            questions?.docs_answers?.find(doc => doc?.question_no === isModalOpen?.data?.question_no)?.answer) || ''}
                      </ParagraphComp>
                      {isModalOpen?.data?.type.toLowerCase() === 'text' ||
                        isModalOpen?.data?.type.toLowerCase() === 'number' ||
                        isModalOpen?.data?.type.toLowerCase() === 'date' ||
                        isModalOpen?.data?.type.toLowerCase() === 'password' ||
                        isModalOpen?.data?.type.toLowerCase() === 'float'
                        ?
                        < div className='mt-[20px]'>
                          <CustomInput required={true}
                            type={isModalOpen?.data?.type?.toLowerCase()}
                            name={isModalOpen?.data?.question_no}
                            value={modalValues?.[isModalOpen?.data?.question_no]}
                            onChange={handleChange} label='New Answer' />
                          <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={modalValues?.[isModalOpen?.data?.question_no] && modalErrors?.[isModalOpen?.data?.question_no]} />
                        </div>
                        :
                        isModalOpen?.data?.type.toLowerCase() === 'dropdown' ?
                          < div className='mt-[20px]'>
                            <CustomSelection
                              imgKey='flag'
                              exDataKey={isModalOpen?.data?.question === 'Country Code' ? 'label' : undefined}
                              mappingKey={isModalOpen?.data?.question === 'Country Code' ? 'phone' : undefined}
                              options={isModalOpen?.data?.question === 'Country Code' ? allCountries : isModalOpen?.data?.options}
                              required={true}
                              value={modalValues?.[isModalOpen?.data.question_no]}
                              onChange={handleChange}
                              name={isModalOpen?.data.question_no}
                              label='New Answer'
                            />
                            <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={modalValues?.[isModalOpen?.data?.question_no] && modalErrors?.[isModalOpen?.data?.question_no]} />
                          </div>
                          : isModalOpen?.data?.type.toLowerCase() === 'multiselect dropdown' ?
                            < div className='mt-[20px]'>
                              <MultipleSelect
                                required={true}
                                options={
                                  isModalOpen?.data?.question_no === "DRQ-00077" ?
                                    isModalOpen?.data?.options?.filter(ele => values?.['DRQ-00076']?.includes(ele.value)) : isModalOpen?.data?.options
                                }
                                maxSelect={isModalOpen?.data.validation === 'Select Upto 3' && 3}
                                mappingKey={isModalOpen?.data?.question_no !== "DRQ-00077" ? "option" : 'option'}
                                onValueChange={(values) => modalMultiSelectedValues(values, setModalFieldValue)}
                                selectedValues={values?.[isModalOpen?.data?.question_no] || []}
                                name={isModalOpen?.data?.question_no}
                                label='New Answer'
                              />
                              <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={modalValues?.[isModalOpen?.data?.question_no] && modalErrors?.[isModalOpen?.data?.question_no]} />
                            </div>
                            :
                            isModalOpen?.data?.type.toLowerCase() === 'attach' ?
                              <div className='mt-[20px]'>
                                <CustomFileInput
                                  required={true}
                                  onChange={(e) => attachFile(e, setModalFieldValue)}
                                  value={modalValues?.[isModalOpen?.data?.question_no]?.file_name}
                                  name={isModalOpen?.data?.question_no}
                                  label="New Answer"
                                />
                                <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={modalValues?.[isModalOpen?.data?.question_no] && modalErrors?.[isModalOpen?.data?.question_no]} />
                              </div>
                              : ''
                      }
                      <div className="flex justify-center mt-[15px]">
                        <ButtonComp
                          disabled={editLoading ? true : false}
                          className="w-[150px] rounded-full bg-[#004878] p-[6px] text-white border-none"
                          type="Submit"
                          text={editLoading ? "Saving..." : "Save"}
                        />
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </ModalComp>
          </Form >
        )}
      </Formik>
    </>
  )
}

export default RecieptsAndPayments